var _path, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNoBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 450",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -0.6060606241226125, -0.4446997344493795)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 396 226",
    "data-background-color": "#77d4fc",
    preserveAspectRatio: "xMidYMid meet",
    height: 570,
    width: 1000,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.2400000000000091,0.17631954034808928)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 225.64735846772965",
    height: 225.64735846772965,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 397.4975999999999 226.77559526006826",
    height: 225.64735846772965,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.701718, 0, 0, 1, 56.547508, 1.451825)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 397.498,
    height: 6.946,
    y: 124.626,
    fill: "#faf9f9",
    opacity: 1,
    strokeWidth: 0,
    stroke: "transparent",
    fillOpacity: 1,
    className: "rect-o-0",
    "data-fill-palette-color": "secondary",
    rx: 3.975,
    id: "o-0",
    "data-palette-color": "#faf9f9",
    x: -0.247,
    style: {
      transformOrigin: "-0.493px 128.099px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.9887999999999693,149.75455423128687)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 77.02104102878138",
    height: 77.02104102878138,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 77.02104102878138",
    height: 77.02104102878138,
    width: 395.52,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 77.02104102878138",
    height: 77.02104102878138,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    viewBox: "6.75 -41.599998474121094 244.92999267578125 47.69999694824219",
    height: 77.02104102878138,
    "data-palette-color": "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,128.53662478484287,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140.42435043031418 106.44307870177586",
    height: 106.44307870177586,
    width: 140.42435043031418,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 7.999999999999993,
    y: 0,
    viewBox: "2.7350001335144043 4.651999473571777 26.530000686645508 22.695999145507812",
    enableBackground: "new 0 0 32 32",
    height: 106.44307870177586,
    width: 124.42435043031419,
    className: "icon-icon-0",
    "data-fill-palette-color": "accent",
    id: "icon-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.709 13.377l7.556-4.362-7.556-4.363v2.598H2.736v3.5h18.973V13.377zM10.291 18.625l-7.556 4.362 7.556 4.361v-2.598h18.974V21.25H10.291V18.625z",
    fill: "#ffffff",
    "data-fill-palette-color": "accent"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 52.0035047848429,
    height: 6.945836965689846,
    y: 98.49724173608601,
    x: 268.9609752151571,
    fill: "#faf9f9",
    "data-fill-palette-color": "secondary"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 52.0035047848429,
    height: 6.945836965689846,
    y: 98.49724173608601,
    x: 76.53311999999997,
    fill: "#faf9f9",
    "data-fill-palette-color": "secondary"
  })))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 225.64735846772965,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoBackground);
export default __webpack_public_path__ + "static/media/logo-no-background.80fe169d225775687da40e5b42056fbc.svg";
export { ForwardRef as ReactComponent };